import { forwardRef, createElement, ReactNode } from 'react';
import styled, { css } from 'styled-components/macro';
import Theme from '../constants/Theme';

interface CardI {
  children: ReactNode;
  className?: string;
  style?: object;
  noShadow?: boolean;
  noPadding?: boolean;
  height?: number;
}

const Card = forwardRef<any, CardI>(({ children, style, className, ...rest }, ref) => {
  return createElement(CardStyling, { ref, style, className, ...rest }, children);
});

export default Card;

const CardStyling = styled.div<{ noShadow?: boolean; noPadding?: boolean; height?: number }>`
  background: ${Theme.colorPalette.white};
  display: inline-flex;
  box-shadow: 0 4px 35px ${Theme.colorPalette.shadow};
  border-radius: 5px;
  min-width: 50px;
  min-height: 50px;
  padding: 20px;
  ${(props) =>
    props.height &&
    css`
      height: ${props.height}px;
    `}
  ${(props) =>
    props.noShadow &&
    css`
      box-shadow: none;
    `}
  ${(props) =>
    props.noPadding &&
    css`
      padding: 0;
    `}
`;
